async function copyToClipboard(element) {
    const text = $(element).text();
    // Consider: wrapping in a try/catch to handle (or obfuscate) potential errors
    await navigator.clipboard.writeText(text);
}

$(document).ready(function () {
    $('#plant-dropdown-menu').on('click', function (event) {
        event.stopPropagation();
    });

    $('#plant-menu-button').parent().on('shown.bs.dropdown', function () {
        $('#plant-filter').focus();
    });

    $('#plant-filter').on('input', function (event) {
        event.stopPropagation();
        const filterValue = $(this).val().toLowerCase();

        $("#plant-filter-options > a").each(function() {
            if ($(this).text().toLowerCase().search(filterValue) > -1) {
                $(this).show();
            }
            else {
                $(this).hide();
            }
        });
    });

    $('#user-dropdown-menu').on('click', function (event) {
        event.stopPropagation();
    });

    $('#copy-active-plant-uid-button').click(function () {
        const activePlantUid = $('#active-plant-uid').text().trim();
        copyToClipboard(activePlantUid);
    });

    $('#land-validations-widget-link').on('click', function (e) {
        e.preventDefault();

        if (landValidationsWidget && !!landValidationsWidget.window) {
            landValidationsWidget.focus();
        } else {
            let features = 'height='+(window.screen.height*.66)+',width=700,resizable=yes';
            let url = '/land-validations-widget';
            landValidationsWidget = window.open(url, 'landValidationsWidget', features);
        }
    });
})